export const FETCH_PICTURE_PROFILE_BUSINESS_REQUEST = 'FETCH_PICTURE_PROFILE_BUSINESS_REQUEST';
export const FETCH_PICTURE_PROFILE_BUSINESS_SUCCESS = 'FETCH_PICTURE_PROFILE_BUSINESS_SUCCESS';
export const FETCH_PICTURE_PROFILE_BUSINESS_FAILURE = 'FETCH_PICTURE_PROFILE_BUSINESS_FAILURE';
